import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { LcsMultiSelectModule } from '@lcs/shared/multi-select';
import { LcsChipInputModule } from '../chip-input/chip-input.module';
import { ChipDisplayPipe, LcsChipMultiSelectTriggerComponent } from './chip-multi-select-trigger.component';
import { LcsChipMultiSelectComponent } from './multi-select.component';

@NgModule({
   declarations: [LcsChipMultiSelectComponent, LcsChipMultiSelectTriggerComponent, ChipDisplayPipe],
   exports: [LcsChipInputModule, LcsChipMultiSelectComponent, LcsChipMultiSelectTriggerComponent, ChipDisplayPipe],
   imports: [CommonModule, MatChipsModule, MatIconModule, MatButtonModule, LcsMultiSelectModule],
})
export class LcsChipMultiSelectModule {}
